import React, { useEffect, useState } from "react"
import { captureMessage } from "@sentry/react"
import { T } from "../../traks"
import { Col, Container, Row } from "reactstrap"
import { PremiumPackageCard } from "../PremiumKeys/Package/PremiumPackageCard"
import { determinePackageDescription, determinePackageName } from "../PremiumKeys/Cart/CartUtils"
import API from "../../API"
import { short_site_id } from "../../Site"


export const PremiumPackages = () => {
    const [packages, setPackages] = useState([]);
    const [packagesNoDiscount, setPackagesNoDiscount] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const showSelectedState = false;

      useEffect(() => {
        API.get('/z/premium_prices', { site_id: short_site_id }, (response, status) => {
            if (status >= 200 && status < 300) {
                setPackages(response.packages);
                setPackagesNoDiscount(response.packages_no_discount);
            } else {
                captureMessage("Failed to fetch premium packages", {
                    level: "error",
                    extra: { status: status, response: response }
                });
            }
        })
    }, []);

    return (
        <React.Fragment>
            <Row className='mt-4'>
                <Col lg="3" md="12" sm="12" className="d-flex pb-2">
                    <PremiumPackageCard 
                    id={1}
                    className="h-100 w-100 mb-3"
                    title={determinePackageName(1)}
                    description={determinePackageDescription(1)}
                    discountedPrice={packages["1"]}
                    price={packagesNoDiscount["1"]}
                    binding={<T>No commitment</T>}
                    setSelectedPackage={setSelectedPackage}
                    selectedPackage={selectedPackage}
                    showSelectedState={showSelectedState}
                    details={[
                        <T>30 Invitations</T>,
                        <T>30 days premium access</T>,
                        <T>All features and markets</T>,
                    ]}
                    />
                </Col>
                <Col lg="3" md="12" sm="12" className="d-flex pb-2">
                    <PremiumPackageCard 
                    id={2}
                    className="h-100 w-100"
                    title={determinePackageName(2)}
                    description={determinePackageDescription(2)}
                    discountedPrice={packages["2"]}
                    price={packagesNoDiscount["2"]}
                    setSelectedPackage={setSelectedPackage}
                    selectedPackage={selectedPackage}
                    showSelectedState={showSelectedState}
                    binding={<T>No commitment</T>}
                    details={[
                        <T>35 Invitations</T>,
                        <T>30 days premium access</T>,
                        <T>All features and markets</T>,
                    ]}
                    />
                </Col>
                <Col lg="3" md="12" sm="12" className="d-flex pb-2">
                    <PremiumPackageCard 
                    id={3}
                    className="h-100 w-100"
                    title={determinePackageName(3)}
                    discountedPrice={packages["3"]}
                    price={packagesNoDiscount["3"]}
                    setSelectedPackage={setSelectedPackage}
                    selectedPackage={selectedPackage}
                    showSelectedState={showSelectedState}
                    binding={<T>No commitment</T>}
                    details={[
                        <T>100 Invitations</T>,
                        <T>30 days premium access</T>,
                        <T>All features and markets</T>,
                    ]}
                    />
                </Col>
                <Col lg="3" md="12" sm="12" className="d-flex pb-2">
                    <PremiumPackageCard 
                    id={4}
                    className="h-100 w-100"
                    title={determinePackageName(4)}
                    discountedPrice={packages["4"]}
                    price={packagesNoDiscount["4"]}
                    setSelectedPackage={setSelectedPackage}
                    selectedPackage={selectedPackage}
                    showSelectedState={showSelectedState}
                    binding={<T>No commitment</T>}
                    details={[
                        <T>200 Invitations</T>,
                        <T>30 days premium access</T>,
                        <T>All features and markets</T>,
                    ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                <span className="fw_900"><T>* If you choose one of the packages, you will also be able to extend the period by either 5 or 11 months for only 1 DKK per participant per month</T></span>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumPackages.js